import { styled } from "@mui/styles";

interface WarningWrapperProps {
  color?: string;
}
export const WarningWrapper = styled("div")(({ color }: WarningWrapperProps) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "90%",
  color: color ?? "red",
  fontFamily: "Söhne",
  fontWeight: 400,
}));
